<template>
  <MainLayout selectMenu="8-1">
    <div v-if="!hasAuth">
      <NoAuth></NoAuth>
    </div>
    <div v-else>
      <Row class="menu-line" type="flex">
        <Col span="12" class="menu-actions"><Button icon="md-add" size="small" type="primary" @click.native="add()">{{
          getTranslation('u030') }}</Button>&nbsp;
          <Button type="info" size="small" icon="md-cloud-download" @click.native="exportRole">{{
          getTranslation("k025")
        }}</Button>
        &nbsp;
        <Upload :action="importUrl" name="file"
          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" :show-upload-list="false"
          class="flex-middle" :on-success="successImport" :on-error="errorImport"><Button type="success"
            icon="md-cloud-upload" size="small">{{ getTranslation('k026') }}</Button></Upload>
          </Col>
      </Row>
      <Affix>
      <Row class="table-header" type="flex">
        <Col flex="1" class="table-cell">{{ getTranslation('m008') }}
        </Col>
        <Col flex="6" class="table-cell">{{ getTranslation('u041') }}
        </Col>
        <Col flex="2" class="table-cell">{{ getTranslation('m013') }}
        </Col>
        <Col flex="3" class="table-cell">{{ getTranslation('m017') }}
        </Col>
        <Col flex="4" class="table-cell">{{ getTranslation('m018') }}
        </Col>
      </Row>
    </Affix>
      <Row v-for="(item,index) in user" :key="item.id" :class="['table-row', index % 2 === 0 ? 'table-row-even' : 'table-row-odd']" type="flex">
        <Col flex="1" class="table-cell">{{ item.id }}
        </Col>
        <Col flex="6" class="table-cell">{{ item.name }}
        </Col>
        <Col flex="2" class="table-cell">{{ item.sort }}
        </Col>
        <Col flex="3" class="table-cell">{{ item.updated_string }}
        </Col>
        <Col flex="4" class="table-cell  action-buttons flex-middle">
        <Button size="small" type="info" icon="md-key" @click.native="auth(item.id)">{{ getTranslation('u044')
          }}</Button>&nbsp;
        <Button size="small" type="primary" icon="md-create" @click.native="edit(item.id)">{{ getTranslation('m019')
          }}</Button>&nbsp;
        <Button size="small" type="error" icon="md-trash" v-if="item.state != 1" @click.native="del(item.id)">{{
          getTranslation('m027') }}</Button>
        <Button size="small" type="success" icon="md-refresh" v-if="item.state == 1"
          @click.native="recovery(item.id)">{{
            getTranslation('m028') }}</Button>
        </Col>
      </Row>
      <Page class="page-line" :total="total" :current="current" :page-size="pageSize" show-total
        @on-change="handlePageChange" @on-page-size-change="handlePageSizeChange" :show-sizer="true"
        :page-size-opts=pageSizeAry>{{ getTranslation('c010') }} {{ total }} {{ getTranslation('c011') }}</Page>
      <RoleEdit v-model="modalVisible" :propVisible="modalVisible" :editId="editId" @refresh-page="refreshPage">
      </RoleEdit>
      <RoleAuth v-model="authVisible" :propVisible="authVisible" :authId="authId" @refresh-page="refreshPage">
      </RoleAuth>
    </div>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/MainLayout.vue'
import { API_URL, PAGE_SIZE_ARY } from '@/constants/const.js'
import axios from 'axios';
import RoleEdit from './components/RoleEdit.vue';

import NoAuth from '@/components/NoAuth.vue'
import RoleAuth from './components/RoleAuth.vue';
import { mapGetters } from 'vuex'
import { postJsError,exportFile,blobToString } from '@/util/util.js'
export default {
  name: 'UserIndex', // 组件名称
  computed: {
    ...mapGetters(['getTranslation']),
    importUrl() {
      return API_URL["roleImport"];
    },
  },
  components: {
    MainLayout, RoleEdit, NoAuth, RoleAuth,
  },
  props: {

  },
  data() {
    return {
      user: [],
      total: 0,
      current: 1,
      pageSize: parseInt(localStorage.getItem('user.page_size')) || 20,
      pageSizeAry: PAGE_SIZE_ARY,
      modalVisible: false,
      editId: 0,
      hasAuth: true,
      authVisible: false,
      authId: 0,
    }
  },
  mounted() {

  },
  created() {
    this.setBreadcrumbItems();
    this.getData();
  },
  methods: {
    getData() {
      let url = API_URL["roleGet"];
      let params = {
        page: this.current,
        page_size: this.pageSize
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.user = res.data.data.data;
            this.total = res.data.data.total;
            this.pageSize = res.data.data.pagination.page_size;
            this.current = res.data.data.pagination.page;
          } else if (res && res.data && res.data.code == 3001) {
            this.hasAuth = false;
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('u020'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    handlePageChange(page) {
      this.current = page;
      this.getData();
    },
    handlePageSizeChange(pageSize) {
      this.current = 1;
      this.pageSize = pageSize;
      localStorage.setItem('user.page_size', this.pageSize)
      this.getData();
    },
    add() {
      //0代表新增
      this.editId = 0;
      this.modalVisible = true
    },
    edit(id) {
      //0代表新增
      this.editId = id;
      this.modalVisible = true
    },
    auth(id) {
      this.authId = id;
      this.authVisible = true
    },
    del(id) {
      let url = API_URL["roleDelete"];
      let params = {
        id: id,
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$Message.success(res.data.msg);
            this.getData();
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    recovery(id) {
      let url = API_URL["roleRecover"];
      let params = {
        id: id,
      }
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.$Message.success(res.data.msg);
            this.getData();
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    refreshPage() {
      this.getData();
    },
    setBreadcrumbItems() {
      if (this.$lang && this.$lang['u004']) {
        this.$store.commit('setBreadcrumbItems', [
          { title: this.getTranslation('u004') }
        ])
      }      
    },
    async exportRole() {
      let params = {
      }
      let exportUrl = API_URL["roleExport"];
      const response = await axios.get(exportUrl, {
        responseType: 'blob',
        params: params,
        timeout: 300000,
      });
      if (response.status == 200) {
        const contentType = response.headers['content-type'];
        if (contentType && contentType.includes('application/json')) {
          blobToString(response.data).then(text => {
            let msgData = JSON.parse(text);
            if (msgData.msg) {
              this.$Message.error(msgData.msg)
            }
          }).catch((err) => {
            postJsError(err)
            this.$Message.error(this.getTranslation('c001'));
          });
        } else {
          exportFile(response)
        }
      } else {
        this.$Message.error(this.getTranslation('c001'));
      }
    },

    successImport(response) {
      if (response && response.code == 200) {
        this.$Message.success(response.msg);        
        this.getData();
      } else if (response && response.msg) {
        this.$Message.error(response.msg);
      }
    }, 
    errorImport() {
      this.$Message.error(this.getTranslation('c001'));
    },
  },

}
</script>

<style scoped>
@import url("../../assets/style/list.css");
</style>